import React from 'react';
import { Container } from '@/components/container';
import { AgentWelcomeBox, AgentUpgradeBox } from './homebox';
import { useNavigate } from 'react-router';
import { ContentLoader } from '@/components/loaders';
import { useCheckPayUser } from '@/hooks/useAuth';
import { useAuth } from '../../../hooks/useAuth';

const AgentsHome = () => {
  const navigate = useNavigate();
  const {userData} = useAuth()

  // Sử dụng hook tanstack query để lấy pay
  const { data, isLoading } = useCheckPayUser(userData?.uID);
  const pay = data?.pay;

  const handleAgent = () => {
    navigate('/agent/builder');
  }

  return (
    <Container className="mt-10">
      <div className="flex flex-col items-center justify-center py-10 gap-6">
        {isLoading && <ContentLoader />}
        {pay === 0 && <AgentUpgradeBox />}
        {pay > 0 && <AgentWelcomeBox onCreate={handleAgent} />}
      </div>
    </Container>
  );
};
export { AgentsHome };
